import { Flex, defaultFlexTag } from "../Flex/Flex";

/**
 * @typedef {import('../Flex/Flex').FlexProps} FlexProps
 * @typedef {Omit<FlexProps, 'direction'>} VStackProps
 */

/**
 * @param {VStackProps & { as?: React.ElementType, children?: React.ReactNode }} props
 */
export const VStack = (props) => {
    const { as, align = "start", ...otherProps } = props;
    const tag = as ?? defaultFlexTag;

    return <Flex direction="column" as={tag} align={align} {...otherProps} />;
};
